import React from 'react';
import TickerContent from './TickerContent';

export default function TickerBanner() {
  return (
    <div className="bg-emerald-50 border-b border-emerald-100 overflow-hidden">
      <div className="relative">
        <div className="flex overflow-x-hidden">
          <TickerContent />
        </div>
        {/* Gradient overlays for smooth fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-emerald-50 to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-emerald-50 to-transparent" />
      </div>
    </div>
  );
}